import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function ClientLine() {
  const ref = useScrollReveal();

  return (
    <section className="relative z-10 px-6 py-28 md:py-40">
      {/* Top divider */}
      <div className="max-w-xs mx-auto mb-20 md:mb-28 h-px bg-white/[0.06]" />

      <div
        ref={ref as React.RefObject<HTMLDivElement>}
        className="reveal max-w-3xl mx-auto text-center"
      >
        <p
          className="font-display font-medium text-white/15 leading-snug tracking-tight"
          style={{ fontSize: 'clamp(1.6rem, 3vw + 0.5rem, 2.8rem)' }}
        >
          Helping businesses grow online
          <br className="hidden sm:block" />
          {' '}through better websites.
        </p>
      </div>

      {/* Bottom divider */}
      <div className="max-w-xs mx-auto mt-20 md:mt-28 h-px bg-white/[0.06]" />
    </section>
  );
}
